module.exports = __webpack_public_path__ + "img/hand.2c104a55.png";